import i18n from '../i18n';

/**
 * Resolve a translation key stored in the API payload and provide a fallback string.
 * @param {Object} options
 * @param {string} options.key - i18n key to resolve
 * @param {Object} [options.params] - Optional interpolation params
 * @param {string} [options.fallback] - Text to use when the key is missing
 * @returns {string}
 */
export const translateFromKey = ({ key, params = {}, fallback = '' } = {}) => {
  if (!key) {
    return fallback || '';
  }

  try {
    return i18n.t(key, { defaultValue: fallback || key, ...params });
  } catch (error) {
    console.warn('[translationHydrator] Failed to resolve key', key, error);
    return fallback || key;
  }
};

const hydrateTimelineEvents = (events = []) => {
  if (!Array.isArray(events)) {
    return [];
  }

  return events.map((event = {}) => ({
    ...event,
    translated_message: translateFromKey({
      key: event.translation_key,
      params: event.translation_params,
      fallback: event.message
    })
  }));
};

export const hydrateDisputeRecord = (dispute = {}) => {
  if (!dispute || typeof dispute !== 'object') {
    return dispute;
  }

  return {
    ...dispute,
    translated_reason: translateFromKey({
      key: dispute.category_key || dispute.reason_key,
      params: dispute.reason_params,
      fallback: dispute.reason
    }),
    events: hydrateTimelineEvents(dispute.events),
    attachments: Array.isArray(dispute.attachments) ? dispute.attachments : []
  };
};

export const hydratePenaltyRecord = (penalty = {}) => {
  if (!penalty || typeof penalty !== 'object') {
    return penalty;
  }

  return {
    ...penalty,
    translated_reason: translateFromKey({
      key: penalty.reason_key,
      params: penalty.reason_params,
      fallback: penalty.reason
    })
  };
};

export const hydrateDisputeCollection = (payload = []) => {
  if (!Array.isArray(payload)) {
    return [];
  }
  return payload.map(hydrateDisputeRecord);
};

export const hydratePenaltyCollection = (payload = []) => {
  if (!Array.isArray(payload)) {
    return [];
  }
  return payload.map(hydratePenaltyRecord);
};
